import { useEffect, useState, useContext } from "react";
import ActivityIndicator from "../../components/ui/activityIndicator/ActivityIndicator";
import AuthContext from "../../components/context/AuthContext";
import axios from "axios";
import Button from "../../components/ui/buttons/Button";
import EditPhotos from "./EditPhotos";
import PhotoPointCard from "../../components/ui/containers/PhotoPointCard";
import SectionHeader from "../../components/ui/labels/SectionHeader";
import useEditPhotoPointPhotos from "./useEditPhotoPointPhotos";
import InfoPrompt from "../../components/ui/prompts/InfoPrompt";
import DevModeLabel from "../../components/ui/labels/DevModeLabel";
import { useNavigate, useLocation } from "react-router-dom";
import styles from "./EditPhotoPointPhotos.module.css";

const EditPhotoPointPhotos = () => {
  const navigate = useNavigate();
  const routeLocation = useLocation();
  const [selectedPhotoPoint] = useState(routeLocation.state);

  // State.
  const authCtx = useContext(AuthContext);
  const [photos, setPhotos] = useState(null);
  const [status, setStatus] = useState(null);
  const [fetchingPhotos, setFetchingPhotos] = useState(true);

  // Business Logic.
  const { handleResponse, responseValid } = useEditPhotoPointPhotos();

  const refecthPhotosHandler = () => {
    setFetchingPhotos(true);
  };

  /*
    1)  Fetch visible attachment IDs for the photo point's object ID.
    2)  Query the photo point layer for the attachments to the photo point's object ID.
    3)  Filter out any photos set to not visible.
    4)  Update the photos state.
  */
  useEffect(() => {
    // Clean up async useEffect flag.
    let isSubscribed = true;
    if (fetchingPhotos) {
      let url = `${process.env.REACT_APP_API_URL}/photopoint/visiblePhotos`;
      let authObj = { headers: { Authorization: `token ${authCtx.token}` } };
      let obj = { parentObjectId: selectedPhotoPoint.OBJECTID };
      axios
        .post(url, obj, authObj)
        .then(async (response) => {
          if (isSubscribed) {
            if (
              !responseValid({
                response: response,
                setStatus: setStatus,
                setFetchingPhotos: setFetchingPhotos,
              })
            )
              return;
            await handleResponse({
              response: response,
              setFetchingPhotos: setFetchingPhotos,
              setPhotos: setPhotos,
              setStatus: setStatus,
            });
          }
        })
        .catch((error) => {
          if (isSubscribed) {
            setFetchingPhotos(false);
            setStatus(
              error?.response?.data
                ? `Error: ${error.response.data}`
                : `Error: ${error}`
            );
          }
        });
    }
    // Cancel subscription to useEffect.
    return () => (isSubscribed = false);
    //eslint-disable-next-line
  }, [selectedPhotoPoint, fetchingPhotos]);

  const cancelEditHandler = () => {
    navigate("/home", {
      replace: true,
      state: {
        latitude: selectedPhotoPoint.LOCATION.latitude,
        longitude: selectedPhotoPoint.LOCATION.longitude,
      },
    });
  };

  return (
    <>
      <SectionHeader text="Edit Photos" overrideFontSize={"24px"} />
      <DevModeLabel />
      <PhotoPointCard selectedPhotoPoint={selectedPhotoPoint} />
      <ActivityIndicator loading={fetchingPhotos} text={"Fetching Photos..."} />
      {!fetchingPhotos && (
        <EditPhotos
          photos={photos}
          refecthPhotosHandler={refecthPhotosHandler}
        />
      )}
      <div className={styles.primaryButtons}>
        <Button onClick={cancelEditHandler} text="Back to Map" />
      </div>

      <InfoPrompt text={status} statusCleared={() => setStatus(null)} />
    </>
  );
};

export default EditPhotoPointPhotos;
